@if (printCommand?.printOptions$ | async; as printOptionsCtx) {
  <div class="flex-none layout-col" [matTooltip]="printOptionsCtx?.options?.printerId">
    <mat-icon>printer</mat-icon>
  </div>
}
